import { FacebookCustomEvent, FacebookStandardEvents } from '@xylabs/react-pixel'

import { AddressInfoData, ContactInfoData } from '../../models'

export interface FacebookContactInfoComplete extends Record<string, unknown>, ContactInfoData {}

export interface FacebookAddressInfoComplete extends Record<string, unknown>, AddressInfoData {}

export interface FacebookUserClick extends Record<string, unknown> {
  elementName: string
  elementType: string
}

export class FacebookEvents<T extends Record<string, unknown>> extends FacebookStandardEvents<T> {
  public contactInfoComplete() {
    return new FacebookCustomEvent<FacebookContactInfoComplete | T>('ContactInfoComplete')
  }

  public addressInfoComplete() {
    return new FacebookCustomEvent<FacebookAddressInfoComplete | T>('AddressInfoComplete')
  }

  public paymentInfoComplete() {
    return new FacebookCustomEvent<T>('PaymentInfoComplete')
  }

  public transactionAttempted() {
    return new FacebookCustomEvent<T>('TransactionAttempted')
  }

  public transactionFailed() {
    return new FacebookCustomEvent<T>('TransactionFailed')
  }

  public transactionCompleted() {
    return new FacebookCustomEvent<T>('TransactionCompleted')
  }

  public upsellViewed() {
    return new FacebookCustomEvent<T>('UpsellViewed')
  }

  public upsellUnavailable() {
    return new FacebookCustomEvent<T>('UpsellUnavailable')
  }

  public upsellAccepted() {
    return new FacebookCustomEvent<T>('UpsellAccepted')
  }

  public upsellSucceeded() {
    return new FacebookCustomEvent<T>('UpsellSucceeded')
  }

  public trialStarted() {
    return new FacebookCustomEvent<T>('TrialStarted')
  }

  public upsellFailed() {
    return new FacebookCustomEvent<T>('UpsellFailed')
  }

  public testStarted() {
    return new FacebookCustomEvent<T>('TestStarted')
  }

  public funnelStarted() {
    return new FacebookCustomEvent<T>('FunnelStarted')
  }

  public funnelStartedStarted() {
    return new FacebookCustomEvent<T>('FunnelStarted')
  }

  public userClick() {
    return new FacebookCustomEvent<FacebookUserClick | T>('UserClick')
  }

  public emailCollected() {
    return new FacebookCustomEvent<{ email: string } | T>('EmailCollected')
  }

  public accountCreated() {
    return new FacebookCustomEvent<T>('AccountCreated')
  }

  public shareCompleted() {
    return new FacebookCustomEvent<T>('ShareCompleted')
  }

  public funnelCompleted() {
    return new FacebookCustomEvent<T>('FunnelCompleted')
  }

  public buyticketsCompleted() {
    return new FacebookCustomEvent<T>('BuyTicketsCompleted')
  }

  public installCompleted() {
    return new FacebookCustomEvent<T>('InstallCompleted')
  }

  public offerRequested() {
    return new FacebookCustomEvent<{ id: string } | T>('OfferRequested')
  }

  public feedbackScoreCollected() {
    return new FacebookCustomEvent<{ score: string | number } | T>('FeedbackScoreCollected')
  }

  public feedbackSourceCollected() {
    return new FacebookCustomEvent<{ source: string } | T>('FeedbackSourceCollected')
  }

  public goodFeedbackRequested() {
    return new FacebookCustomEvent<T>('GoodFeedbackRequested')
  }

  public badFeedbackRequested() {
    return new FacebookCustomEvent<T>('BadFeedbackRequested')
  }
}
